import React, { Component,} from 'react';
import { connect } from 'react-redux';
import { Card, Form } from 'react-bootstrap';
import Style from './AdvancedSettings.module.css';
import {
  getCustomerLicenseType,
  updateCustomerLicenseType,
  unSetStatusCode
} from '../store/entities/customers';
import { getLicenseTypeLookupData } from '../store/entities/lookup';
import LoaderWrapper from "./common/LoaderWrapper/LoaderWrapper";
import ConfirmPopup from "./common/popover/confirmPopup";


class LicenseTypeSettings extends Component {

  constructor(props) {
    super(props)
    this.state = {
        licenseType : "BASICPHISH",
        showConfirmationPopup: false
      };
  }

  componentDidMount() {
    this.props.getLicenseTypeLookupData();
    if (this.props.selectedCustomer?.id) {
      this.props.getCustomerLicenseType(this.props.selectedCustomer.id);
      this.setState({
        licenseType: this.props.licenseType
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.licenseType && prevProps.licenseType !== this.props.licenseType) {
      let licenseType = this.props.licenseType
      if(licenseType){
          this.setState({
              licenseType : licenseType
          })
      }
      else {
          console.warn("licenseType settings not found! Setting default settings")
          this.setState({
              licenseType : "BASICPHISH"
          })
      }
    }

    if(prevProps.selectedCustomer !== this.props.selectedCustomer){
      this.props.getCustomerLicenseType(this.props.selectedCustomer.id)
    }
  }

  handleLicenseTypeChange = (e) => {
    let selectedCode = e.target.value;
    this.setState({
      licenseType: selectedCode,
      showConfirmationPopup: true
    });
  }

  handleOnClose = () => { 
    this.setState({
      licenseType: this.props.licenseType,
      showConfirmationPopup: false
    })
    this.props.unSetStatusCode();
  }

  updateLicenseType = () => {
    this.setState({
      showConfirmationPopup: false
    })
    this.props.updateCustomerLicenseType(this.props.selectedCustomer?.id, {
      licenseType: this.state.licenseType
    });
  }

render() {
  let {licenseTypeLoading} = this.props;
  return (

    <div className={`mt-3 h-100`}>
      <>
        <div className={`${Style.profileFontStyle}`}>
               License Type Settings
            </div>
        <Card className="" style={{width: "641px", height:"auto", minHeight:"150px" }}>
        {
      licenseTypeLoading ?
      <LoaderWrapper loading={licenseTypeLoading} waitForData={false}></LoaderWrapper>
      :
            <Card.Body>
              <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className={`${Style.textStyle}`} style={{ fontSize: '20px' }}>License Type: </Form.Label>
                        <Form.Control as="select" name="licenseType" onChange={(e) => this.handleLicenseTypeChange(e)} value={this.state.licenseType}>
                            {
                                this.props.lookupData.map((licenseType) => (
                                  licenseType.lookupId === "LKP_LICENSE_TYPE" &&
                                    <option key={licenseType.code} value={licenseType.code}>{licenseType.value}</option>
                                ))
                            }
                        </Form.Control>
                    </Form.Group>
                <Form.Text muted>Select a license type for this customer. The License Type defines what security features they can access, such as phishing protection or threat intelligence or both</Form.Text><br/>

              </Form>
            </Card.Body>
        }
        </Card>
        </>  
        {this.state.showConfirmationPopup && (
          <ConfirmPopup
          details={{
            icon: '',
            type: 'info',
            title: 'Are You Sure?',
            description: "Do you want to update the License Type? This will affect how the Customer can access Pixm Resources",
            buttons: 'Y,C',
          }}
          onCancelClick={this.handleOnClose} 
          onYesClick= {this.updateLicenseType}
          />
        )}

        {
          this.props.statusCode && (
            <ConfirmPopup
            details={{
              icon: '',
              type: this.props.statusCode ===  200? 'success':'error',
              title: this.props.statusCode ===  200? `License Type Updated Successfully`:`License Type Could not be updated`,
              description: this.props.userMsg || "Error in updating License Type. Contact support",
              buttons: 'O',
            }}
            onCloseClick={this.handleOnClose} 
          />
          )}
    </div>
  );
};
}

const mapStateToProps = (state) => ({
  userRole: state.entities.user.roles,
  selectedCustomer: state.entities.customers.selected,
  licenseType: state.entities.customers.licenseType,
  statusCode : state.entities.customers.statusCode,
  userMsg : state.entities.customers.userMsg,
  licenseTypeLoading : state.entities.customers.licenseTypeLoading,
  lookupData: state.entities.lookup.data
});

const mapDispatchToProps = (dispatch) => ({
  getCustomerLicenseType: (customerId) => dispatch(getCustomerLicenseType(customerId)),
  updateCustomerLicenseType: (customerId, data) => dispatch(updateCustomerLicenseType(customerId, data)),
  getLicenseTypeLookupData: () => dispatch(getLicenseTypeLookupData()),
  unSetStatusCode: () => dispatch(unSetStatusCode())
})  

export default connect(mapStateToProps, mapDispatchToProps)(LicenseTypeSettings);